import User from '../../../api/User';
import * as types from './mutation-types';
import * as constants from '../../../utils/constants';

export const show = async ({commit}, {id}) => {
    const json = await new User().show(id);
    commit(types.USER_FILL_INFO, json.data);
};

export const clear = ({commit}) => {
    commit(types.USER_CLEAR_INFO);
};

export const create = async ({commit}, {params}) => {
    const json = await new User().store(params);

    commit(types.ID, json.data.id);
    commit(types.CREATED_AT, json.data.created_at);
    //Temporary
    commit(types.ROLE, json.data.role);
    commit(types.COUNTRY, json.data.country);
    return json;
};

export const update = async ({}, {params}) => {
    return await new User().update(params.id, params);
};

export const destroy = async ({}, {id}) => {
    return await new User().destroy(id);
};

export const lock = async ({}, {params}) => {
    return await new User().lock(params);
};

export default {
    show,
    clear,
    create,
    update,
    destroy,
    lock,
};



// WEBPACK FOOTER //
// ./src/store/modules/user/actions.js